import fiveStarGeneral from '../pieces/five-star-general.png'
import fourStarGeneral from '../pieces/four-star-general.png'
import threeStarGeneral from '../pieces/three-star-general.png'
import twoStarGeneral from '../pieces/two-star-general.png'
import oneStarGeneral from '../pieces/one-star-general.png'
import captain from '../pieces/captain.png'
import colonel from '../pieces/colonel.png'
import hidden from '../pieces/hidden.png'
import lieutenantColonel from '../pieces/lieutenant colonel.png'
import privateP from '../pieces/private.png'
import spy from '../pieces/spy.png'
import major from '../pieces/major.png'
import sergeant from '../pieces/sergeant.png'
import firstLieutenant from '../pieces/first-lieutenant.png'
import secondLieutenant from '../pieces/second-lieutenant.png'
import flag from '../pieces/flag.png'

export const pieceImage = {
  "SP": spy,
  "5S": fiveStarGeneral,
  "4S": fourStarGeneral,
  "3S": threeStarGeneral,
  "2S": twoStarGeneral,
  "1S": oneStarGeneral,
  "C": colonel,
  "LC": lieutenantColonel,
  "M": major,
  "CA": captain,
  "1L": firstLieutenant,
  "2L": secondLieutenant,
  "S": sergeant,
  "P": privateP,
  "F": flag,
};

export const pieceNames = {
  "SP": "Spy",
  "5S": "5-Star General",
  "4S": "4-Star General",
  "3S": "3-Star General",
  "2S": "2-Star General",
  "1S": "1-Star General",
  "C": "Colonel",
  "LC": "Lt. Colonel",
  "M": "Major",
  "CA": "Captain",
  "1L": "1st Lieutenant",
  "2L": "2nd Lieutenant",
  "S": "Sergeant",
  "P": "Private",
  "F": "Flag",
};

export const pieces = {
  "SP": 14,
  "5S": 13,
  "4S": 12,
  "3S": 11,
  "2S": 10,
  "1S": 9,
  "C": 8,
  "LC": 7,
  "M": 6,
  "CA": 5,
  "1L": 4,
  "2L": 3,
  "S": 2,
  "P": 1,
  "F": 0,
};

export const ALL_PIECE_TYPES = ["SP", "5S", "4S", "3S", "2S", "1S", "C", "LC", "M", "CA", "1L", "2L", "S", "P", "F"];

export { hidden };
